import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

function plural(word, num) {
  var forms = word.split("_");
  return num % 10 === 1 && num % 100 !== 11
    ? forms[0]
    : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
    ? forms[1]
    : forms[2];
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
  var format = {
    ss: withoutSuffix ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
    mm: withoutSuffix ? "минута_минуты_минут" : "минуту_минуты_минут",
    hh: "час_часа_часов",
    dd: "день_дня_дней",
    MM: "месяц_месяца_месяцев",
    yy: "год_года_лет"
  };
  if (key === "m") {
    return withoutSuffix ? "минута" : "минуту";
  } else {
    return number + " " + plural(format[key], +number);
  }
}

moment.locale("ru");

moment.updateLocale("en", {
  relativeTime: {
    future: "через %s",
    past: "%s назад",
    s: "минуту",
    ss: "минуту",
    m: "минуту",
    mm: relativeTimeWithPlural,
    h: "час",
    hh: relativeTimeWithPlural,
    d: "день",
    dd: relativeTimeWithPlural,
    M: "месяц",
    MM: relativeTimeWithPlural,
    y: "год",
    yy: relativeTimeWithPlural
  }
});

export default class RelativeTime extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      time: moment(this.props.time).fromNow()
    };
  }

  /*componentDidMount() {
        this.interval = setInterval(() => {
            this.setState({ time: this.props.time.fromNow() });
        }, 1000);
    }*/

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return this.state.time;
  }
}

RelativeTime.propTypes = {
  time: PropTypes.string
};
